module.exports = __webpack_public_path__ + "img/logo.e51a2072.png";